import { useRef, useCallback } from 'react';

// reason: this function does not care about arg types. it should work with any arguments passed
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function useDebouncedCallback(callback, delay) {
    const timeoutRef = useRef();
    return useCallback((...args)=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(()=>{
            callback(...args);
        }, delay);
    }, [
        callback,
        delay
    ]);
}

export { useDebouncedCallback };
//# sourceMappingURL=use-debounced-callback.js.map
